import React, { Component, Fragment } from "react";
// import data from "./data.json";
import $ from "jquery";
import PropTypes from "prop-types";
import "./skittle.scss";

class Skittle extends Component {
  state = {
    headerData: [],
    acData: [],
    chartID: "",
    canvasID: "",
    displayEmptyBlock: null,
    YearWiseData: {},
    startXPos: 10,
    startYPos: 50,
    r: 255,
    g: 255,
    b: 255,
    w: 120,
    h: 24,
    vgap: 24 + 2,
    hgap: 120 + 2,
    oldAC: "",
    sortCol: 0,
    display: "none",
    chartWidth: 0,
  };
  componentDidMount() {
    this.setState(
      {
        headerData: this.props.heading,
        acData: this.props.data,
        chartID: this.props.id,
        canvasID: this.props.canvasId,
        displayEmptyBlock: this.props.displayEmptyBlock,
        YearWiseData: this.props.YearWiseData,
        chartWidth: this.props.width,
      },
      () => this.drawSkittleChart(null),
      () => this.drawLegend(this.props.height)
    );
  }
  componentWillReceiveProps(nextProps) {
    this.setState(
      {
        headerData: nextProps.heading,
        acData: nextProps.data,
        chartID: nextProps.id,
        canvasID: nextProps.canvasId,
        displayEmptyBlock: nextProps.displayEmptyBlock,
        YearWiseData: nextProps.YearWiseData,
        chartWidth: nextProps.width,
      },
      () => this.drawSkittleChart(null),
      () => this.drawLegend(nextProps.height)
    );
  }
  drawSkittleChart = (ac) => {
    const {
      chartID,
      canvasID,
      acData,
      w,
      h,
      startXPos,
      vgap,
      hgap,
      oldAC,
      headerData,
      displayEmptyBlock,
      chartWidth,
    } = this.state;
    const height =
      this.props.height == "-Infinity" || this.props.height == null
        ? 200
        : this.props.height;
    if (oldAC === ac) {
      ac = null;
    }
    var canvas = document.getElementById(canvasID);
    if (!canvasID) return;
    if (canvas.getContext) {
      let x = startXPos,
        // y = startYPos;
        y = height - 185;
      var ctx = canvas.getContext("2d");
      $(`#${chartID} > div`).remove();
      ctx.clearRect(0, 0, chartWidth, height);

      for (let i = 0; i < headerData.length - 3; i++) {
        //i= number of years in headerData
        ctx.fillStyle = "rgb(50,50,50)";
        ctx.font = "16px sans-serif";
        ctx.fillText(headerData[i + 1], x + 25, y + 50);

        var sortCol = i + 1;
        const sortAsc = (a, b) => {
          a = parseFloat(a[sortCol]) / 100;
          b = parseFloat(b[sortCol]) / 100;
          return a === b ? 0 : a < b ? -1 : 1;
        };

        acData.sort(sortAsc);
        //  axis event handler
        this.addAxisDiv(x, y + 10, w, h, headerData[i + 1]);
        for (let j = 0; j < acData.length; j++) {
          //j=total number of rows in acData
          ctx.fillStyle = "rgb(" + acData[j][acData[j].length - 2] + ")";
          if (ac != null) {
            if (ac === acData[j][0]) {
              ctx.fillStyle = "rgb(" + acData[j][acData[j].length - 2] + ")";
            } else {
              ctx.fillStyle =
                "rgba(" + acData[j][acData[j].length - 2] + ",0.2)";
            }
          }

          if (acData[j][i + 1] !== "0.00%") {
            ctx.fillRect(x, y, w, h);
            ctx.font = "bold 10px sans-serif";
            ctx.fillStyle = "rgb(255,255,255)";
            // rectangle text
            ctx.fillText(
              acData[j][acData[j].length - 1] + " : " + acData[j][i + 1],
              // "ABCD:1234",
              x + 15,
              y + 15
            );
          }
          if (displayEmptyBlock) {
            this.addDiv(x, y, w, h, acData[j][0], acData[j][i + 1]);
            y = y - vgap;
          } else {
            if (acData[j][i + 1] !== "0.00%") {
              this.addDiv(x, y, w, h, acData[j][0], acData[j][i + 1]);
              y = y - vgap;
            }
          }
        }
        x = x + hgap;
        // y = startYPos;
        y = height - 185;
      }
    }
    // oldAC = ac;
    this.setState({
      oldAC: ac,
    });
  };

  // sortAsc = (a, b) => {
  //   const {sortCol} = this.state;
  //   a = parseFloat(a[sortCol]) / 100;
  //   b = parseFloat(b[sortCol]) / 100;
  //   return a === b ? 0 : a < b ? 1 : -1;
  // };

  addDiv = (x, y, w, h, ac, value) => {
    const { chartID } = this.state;
    var el = document.createElement("div");
    el.style.left = x + 0 + "px"; //0px padding for margin
    el.style.top = y + 0 + "px"; //48px padding for margin
    el.style.width = w + "px";
    el.style.height = h + "px";
    el.classList.add("skittle");
    el.classList.add("skittle-tooltip");

    el.innerHTML = `<span class="skittle-tooltipText">${ac} : ${value}<span>`;

    el.addEventListener("click", (event) => {
      this.drawSkittleChart(ac);
      this.drawLegend(this.props.height);
    });
    document.getElementById(chartID).appendChild(el);
  };

  addAxisDiv = (x, y, w, h, text) => {
    const { chartID, canvasID } = this.state;
    let el = document.createElement("div");
    el.setAttribute("value", text);
    el.style.position = "absolute";
    el.style.left = x + 0 + "px"; //0px padding for margin
    el.style.top = y + 20 + "px"; //48px padding for margin
    el.style.width = w + "px";
    el.style.height = h + "px";
    el.style.cursor = "pointer";
    // el.style.border = "1px solid red";

    el.addEventListener("click", (event) => {
      let element = el.getAttribute("value");
      let YearWiseData = this.props.YearWiseData;

      if (element.toString().length === 4) {
        this.setState(
          {
            acData: YearWiseData.data[element],
            headerData: YearWiseData.header[element],
            display: "block",
          },
          () => {
            this.drawSkittleChart(null);
            this.drawLegend(this.props.height);
            // document.getElementById("style_exposure_back_button").style.display="block";
          }
        );
      } else {
        this.setState(
          {
            acData: this.props.data,
            headerData: this.props.heading,
            display: "none",
          },
          () => {
            this.drawSkittleChart(null);
            this.drawLegend(this.props.height);
            // document.getElementById("style_exposure_back_button").style.display="none";
          }
        );
      }
    });
    document.getElementById(chartID).appendChild(el);
  };

  drawLegend = (height = 200) => {
    const { acData, chartID, startXPos } = this.state;
    //lets paint the legend
    var xPos = 0 + startXPos,
      // yPos = 550 + startYPos,
      yPos = height - 115,
      scWidth = 40,
      scHeight = 20,
      acWidth = 175,
      acHeight = 15;

    for (let j = 0; j < acData.length; j++) {
      if (xPos > startXPos + 1400) {
        xPos = startXPos + 0;
        yPos = yPos + scHeight + 5;
      }

      var el1 = document.createElement("div"); //for Asset Class legend rect
      var el2 = document.createElement("div"); //for Asset Class Label

      el1.style.position = "absolute";
      el1.style.left = xPos + "px";
      el1.style.top = yPos - 6 + "px";
      // el1.innerHTML = " ▣ ";
      el1.innerHTML = "●";
      el1.style.color = "rgb(" + acData[j][acData[j].length - 2] + ")";
      el1.style.fontSize = "25px";

      xPos = xPos + scWidth;
      el2.style.position = "absolute";
      el2.style.left = xPos + "px";
      el2.style.top = yPos + "px";
      el2.style.width = acWidth + "px";
      el2.style.height = acHeight + "px";
      el2.style.paddingTop = "5px";

      el2.style.fontSize = "10px";
      el2.style.fontFamily = "sans-serif";
      el2.innerHTML = `${acData[j][0]}-(${acData[j][acData[j].length - 1]})`;

      document.getElementById(chartID).appendChild(el1);
      document.getElementById(chartID).appendChild(el2);
      xPos = xPos + acWidth + 5;
    }
  };
  // reset drill by back button
  resetDrilldown = () => {
    this.setState(
      {
        acData: this.props.data,
        headerData: this.props.heading,
        display: "none",
      },
      () => {
        this.drawSkittleChart(null);
        this.drawLegend(this.props.height);
      }
    );
  };
  render() {
    const { chartID, canvasID, display, chartWidth } = this.state;
    const { height } = this.props;
    return (
      <Fragment>
        <div id="style_exposure_back_button" style={{ display: display }}>
          <i
            className="fa fa-arrow-left fa-1x"
            style={{ fontSize: "18px", color: "#5262ad", cursor: "pointer" }}
            onClick={this.resetDrilldown}
          ></i>
        </div>
        <div
          id={chartID}
          style={{ width: "100%", position: "relative", overflowX: "auto" }}
        >
          <canvas
            id={canvasID}
            height={height == "-Infinity" ? 200 : height}
            width={chartWidth}
          />
        </div>
      </Fragment>
    );
  }
}

Skittle.propTypes = {
  containerWidth: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number,
  canvasId: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  heading: PropTypes.array.isRequired,
  YearWiseData: PropTypes.shape({
    data: PropTypes.object,
    heading: PropTypes.object,
  }),
};

export default Skittle;



// WEBPACK FOOTER //
// ./src/components/d3Components/skittlesChart/skittle.jsx